import React, { useState } from "react";
import laftahIcon from "../assets/images/laftahLogo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faChevronDown, faClose } from "@fortawesome/free-solid-svg-icons";
import { HashLink as LinkScroll } from 'react-router-hash-link';
import { useLanguage } from "../contexts/LanguageContext";
import { useLocation, useNavigate } from "react-router-dom";
import './header.css';
import { header } from "../utils/translations";

export default function Header() {
  const [isOpen , setIsOpen] = useState(false);
  const { language, toggleLanguage } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();

  const menuToggle = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <header className= {`header ${language === "ar" ? "arab" : ""}`}>
      <img src={laftahIcon} alt="Logo" className="header-logo" />
      <div className="header-navs">
        <div className={`header-nav ${isOpen ? "open" : ""} ${language === "ar" ? "rtl" : ""}`}>
          <LinkScroll onClick={menuToggle} smooth to="/" className="header-navLink">
            {header[language].home}
          </LinkScroll>
          <LinkScroll onClick={menuToggle} smooth to="/#about-us" className="header-navLink">
            {header[language].about}
          </LinkScroll>
          <LinkScroll onClick={menuToggle} smooth to="/#services" className="header-navLink">
            {header[language].services}
          </LinkScroll>
          <LinkScroll onClick={menuToggle} smooth to="/#contact" className="header-navLink">
            {header[language].contact}
          </LinkScroll>
        </div>
      </div>
      <div className="header-navRight">
        <FontAwesomeIcon className="header-menu" onClick={menuToggle} icon={isOpen ? faClose : faBars}></FontAwesomeIcon>
        <div onClick={toggleLanguage} className="header-languageSelector">
          <p className="header-languageText">{header[language].language}</p>
          <FontAwesomeIcon icon={faChevronDown} className="header-languageIcon" />
        </div>
      </div>
    </header>
  );
}
